const USER_EMAIL_BASE = "/admin/users/send_email";
const GROUP_EMAIL_BASE = "/admin/groups/send_email";
const LINK_REGEX = /^https?:\/\/.+/i;

/**
 * Returns the empty initial state of the send-email form.
 * @returns {Object} Form with empty message, subject, link and link_label
 */
function buildInitialEmailForm() {
    return { message: "", subject: "", link: "", link_label: "" };
}

/**
 * Validates the form before submission. Message is mandatory and, when a link
 * is provided, it must use an http(s) scheme (mirrors the server-side check).
 * @param {Object} form - Current form state
 * @returns {string|null} A French error message, or null when the form is valid
 */
function validateEmailForm(form) {
    if (!form.message || !form.message.trim()) return "Le message est obligatoire";
    if (form.link && form.link.trim() && !LINK_REGEX.test(form.link.trim())) {
        return "Le lien doit commencer par http:// ou https://";
    }
    return null;
}

/**
 * Builds the request payload. The message keeps its line breaks (sent untrimmed);
 * optional fields are trimmed and omitted when empty.
 * @param {Object} form - Current form state
 * @returns {Object} JSON payload accepted by both send_email endpoints
 */
function buildEmailPayload(form) {
    const payload = { message: form.message };
    if (form.subject?.trim()) payload.subject = form.subject.trim();
    if (form.link?.trim()) payload.link = form.link.trim();
    if (form.link_label?.trim()) payload.link_label = form.link_label.trim();
    return payload;
}

/**
 * Builds the axios config to email a single user, meant to be passed to
 * runWith2FA so the shared 2FA flow handles the OTP challenge.
 * @param {number|string} userId - Target user id
 * @param {Object} payload - Result of buildEmailPayload
 * @returns {Object} Axios request config
 */
function buildUserEmailConfig(userId, payload) {
    return { method: "post", url: `${USER_EMAIL_BASE}/${userId}`, data: payload };
}

/**
 * Builds the axios config to email all active members of a group, meant to be
 * passed to runWith2FA.
 * @param {number|string} groupId - Target group id
 * @param {Object} payload - Result of buildEmailPayload
 * @returns {Object} Axios request config
 */
function buildGroupEmailConfig(groupId, payload) {
    return { method: "post", url: `${GROUP_EMAIL_BASE}/${groupId}`, data: payload };
}

export {
    buildInitialEmailForm, validateEmailForm, buildEmailPayload,
    buildUserEmailConfig, buildGroupEmailConfig,
};
